import React from 'react';
import Modal from './Modal';
import ModalHeader from './ModalHeader';

const ModalBody = ({ children }) => <div className="modal-body">{children}</div>;
const ModalFooter = ({ children }) => <div className="modal-footer">{children}</div>;

const mixed = { Modal, ModalBody, ModalHeader, ModalFooter };
export default mixed;
